import { StringAvatar } from '@eye-able/ui';
import { avatarColors } from '@helpers/constants';
import { getUserFullName } from '@helpers/getUserFullName';
import { UserIcon } from 'lucide-react';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export default function UserAvatar({
  user,
  me = false,
  hideName = false,
  titleStyle = {},
  label = null,
  style = {},
}) {
  const { t } = useInlineTranslation();
  const fullName = getUserFullName(user);

  const userAvatar = (
    <div className='eye:shrink-0'>
      <StringAvatar
        bgColor={
          user
            ? me
              ? avatarColors.me
              : avatarColors[user.orgAdmin]
            : '#bdbdbd'
        }
        icon={user ? null : <UserIcon aria-hidden size={16} />}
        small
        text={fullName}
      />
    </div>
  );

  return hideName ? (
    userAvatar
  ) : (
    <div className='eye:flex eye:items-center eye:gap-12' style={style}>
      {userAvatar}

      <div
        className={me ? 'eye:font-semibold' : 'eye:font-regular'}
        style={titleStyle}
      >
        {user ? (label ?? fullName) : t('unassigned')}
      </div>
    </div>
  );
}
